// extracted by mini-css-extract-plugin
export var dividerLine = "_4l-0";
export var errorBackground = "_4l-1";